export default "__VITE_ASSET__pfq3tucsL0bPidwvkDYjtw__"